export function normalizeItalianPhone(localNumber: string): string {
  if (/[^\d\s()+-]/.test(localNumber)) throw new Error('invalid phone');
  const digits = italianNationalNumber(localNumber);
  if (!/^\d+$/.test(digits)) throw new Error('invalid phone');
  return `+39${digits}`;
}

export function italianNationalNumber(value: string): string {
  const trimmed = value.trim();
  const hasInternationalPrefix = /^\+39/.test(trimmed) || /^0039/.test(trimmed);
  const digits = trimmed.replace(/\D/g, '');
  if (hasInternationalPrefix) return digits.replace(/^(?:0039|39)/, '');
  return digits;
}
